// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    display: grid;
    grid-template: 125px / repeat(6, minmax(150px, 1fr));
    grid-gap: 10px;
    background-color: #bfbfbf;
    padding: 10px;
    background-image: url("https://anagrams.ca/api/images/background_1.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
}

.navbar-component {
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    display: block;
    width: 100%;
    height: 110%;
    margin-top: 10px;
}
.navbar-home {
    background-image: url("https://anagrams.ca/api/images/home_bg_1.png");

}

.navbar-anagrams-solo {
    background-image: url("https://anagrams.ca/api/images/anagrams_bg.png");

}
.navbar-anagrams-multiplayer {
    background-image: url("https://anagrams.ca/api/images/anagrams_mp_1.png");

}
.navbar-conn4 {
    background-image: url("https://anagrams.ca/api/images/connfour_3.png");

}
.navbar-battleship {
    background-image: url("https://anagrams.ca/api/images/battleship_1.png");
}
.navbar-dotsboxes {
    background-image: url("https://anagrams.ca/api/images/dotsboxes_1.png");
}

.navbar div {
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  align-content: center;
  padding: 5px 0 20px 0;
  font-size: 30px;
}
.navbar div {
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/css/NavBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oDAAoD;IACpD,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,wEAAwE;IACxE,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,qEAAqE;;AAEzE;;AAEA;IACI,uEAAuE;;AAE3E;AACA;IACI,yEAAyE;;AAE7E;AACA;IACI,sEAAsE;;AAE1E;AACA;IACI,wEAAwE;AAC5E;AACA;IACI,uEAAuE;AAC3E;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B","sourcesContent":[".navbar {\r\n    display: grid;\r\n    grid-template: 125px / repeat(6, minmax(150px, 1fr));\r\n    grid-gap: 10px;\r\n    background-color: #bfbfbf;\r\n    padding: 10px;\r\n    background-image: url(\"https://anagrams.ca/api/images/background_1.png\");\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    background-size: 100% 100%;\r\n}\r\n\r\n.navbar-component {\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    background-size: contain;\r\n    display: block;\r\n    width: 100%;\r\n    height: 110%;\r\n    margin-top: 10px;\r\n}\r\n.navbar-home {\r\n    background-image: url(\"https://anagrams.ca/api/images/home_bg_1.png\");\r\n\r\n}\r\n\r\n.navbar-anagrams-solo {\r\n    background-image: url(\"https://anagrams.ca/api/images/anagrams_bg.png\");\r\n\r\n}\r\n.navbar-anagrams-multiplayer {\r\n    background-image: url(\"https://anagrams.ca/api/images/anagrams_mp_1.png\");\r\n\r\n}\r\n.navbar-conn4 {\r\n    background-image: url(\"https://anagrams.ca/api/images/connfour_3.png\");\r\n\r\n}\r\n.navbar-battleship {\r\n    background-image: url(\"https://anagrams.ca/api/images/battleship_1.png\");\r\n}\r\n.navbar-dotsboxes {\r\n    background-image: url(\"https://anagrams.ca/api/images/dotsboxes_1.png\");\r\n}\r\n\r\n.navbar div {\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n  text-align: center;\r\n  align-content: center;\r\n  padding: 5px 0 20px 0;\r\n  font-size: 30px;\r\n}\r\n.navbar div {\r\n  background-color: transparent;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
